import get from 'lodash/get'
import without from 'lodash/without'
import split from 'lodash/split'
import trim from 'lodash/trim'
import join from 'lodash/join'

export default {
  bind(element, binding) {
    const isWrapper = get(binding, 'value', false) === 'wrapper'
    const tagetImg = isWrapper ? element.firstElementChild : element

    tagetImg.onload = function() {
      let orientation = ''
      const ratio = this.width / this.height
      if (ratio < 1) {
        orientation = 'portrait'
      } else {
        orientation = 'landscape'
        if (ratio === 1) orientation = 'square'

        if (isWrapper) {
          element.style['min-height'] = `${this.height}px`
        }
      }

      const classList = split(trim(get(element, 'classList.value', '')), ' ')
      element.classList = `${join(without(classList, 'portrait', 'landscape', 'square'), ' ')} ${orientation}`
    }
  },
}



// WEBPACK FOOTER //
// ./directives/imageOrientation.js